module.exports = __webpack_public_path__ + "static/media/detailedFootballWhite.43224c58.svg";